/* React & React Native libraries */
import { Text, View, ScrollView } from 'react-native'

/* Custom Components and Constants */
import TutorialContent from './_components/TutorialContent.js'

import { i18n } from '$localization/config.js'

/* Custom Stylesheets */
import global_styles from '$constants/styles/global.styles.js'

const RelationshipInfoTutorialPage1 = ({ colorSettings }) => (
  <View
    style={[
      global_styles.content,
      {
        backgroundColor: 'transparent',
        flex: 1.0,
      },
    ]}
  >
    <View style={{ paddingHorizontal: 16, paddingVertical: 16 }}>
      <Text
        style={[
          global_styles.headerBarMainTitle,
          {
            color: colorSettings?.text_input_title_color_2,
          },
        ]}
      >
        {i18n.t('children_from_different_partners')?.capitalize}
      </Text>
    </View>
    <ScrollView
      style={{ width: '100%' }}
      contentContainerStyle={{ paddingHorizontal: 24, paddingVertical: 24 }}
    >
      <View style={global_styles.webContainer}>
        <TutorialContent
          colorSettings={colorSettings}
          numberImageSource={require('$assets/images/new_assets/t-1.png')}
          descriptionText={i18n.t('tap_the_profile')?.default}
          demoImageSource={require('$assets/images/new_assets/t1-img1.png')}
        />

        <View style={{ height: 48 }} />

        <TutorialContent
          colorSettings={colorSettings}
          numberImageSource={require('$assets/images/new_assets/t-2.png')}
          descriptionText={
            i18n.t(
              'scroll_to_relationship_section_and_select_the_parent_to_change'
            )?.default
          }
          demoImageSource={require('$assets/images/new_assets/t1-img2.png')}
        />

        <View style={{ height: 48 }} />
        <TutorialContent
          colorSettings={colorSettings}
          numberImageSource={require('$assets/images/new_assets/t-3.png')}
          descriptionText={i18n.t('add_a_new_parent_and_set_the_name')?.default}
          demoImageSource={require('$assets/images/new_assets/t1-img3.png')}
        />
      </View>
    </ScrollView>
  </View>
)

export default RelationshipInfoTutorialPage1
